// extracted by mini-css-extract-plugin
export default {"p":"Binary_p__9kD6d","subtext":"Binary_subtext__uRdHq","exhibitor":"Binary_exhibitor__O6-0P","buttons":"Binary_buttons__29C+S","option":"Binary_option__VqowU"};